module.exports = __webpack_public_path__ + "static/img/8-10.19d63dc2.jpg";